export function checkIfClinicPeopleEverSaved({ clinic } = {}) {
  const isDoctorsArrayEmpty = !clinic?.doctors || !clinic?.doctors?.length
  const isTherapistsArrayEmpty = !clinic?.therapists || !clinic?.therapists?.length
  const isAssistantsArrayEmpty = !clinic?.assistants || !clinic?.assistants?.length

  return !(isDoctorsArrayEmpty && isTherapistsArrayEmpty && isAssistantsArrayEmpty)

  // doctors: savedClnData?.doctors || [],
  // therapists: savedClnData?.therapists || [],
  // assistants: savedClnData?.assistants || [],
}
